module.exports = __webpack_public_path__ + "img/introductionToBlockChain.5830a585.jpg";